import React from 'react';
import { ReactComponent as HutricsLogo } from 'svg/hutrics-logo-color.svg';

function AssessmentHeader() {
  return (
    <div className="container-fluid bg-white">
      <div className="row justify-content-center bg-dark pb-2">
        <div className="col-auto px-3">
          <HutricsLogo className="my-2 pt-2 pb-2" style={{ height: '80px' }} />
        </div>
      </div>
    </div>
  );
}

export default AssessmentHeader;
